import isMobile from '../../plugins/is-mobile.js';

if ($('.l-offrice_block').length || $('.l-mymannan_block').length || $('.l-toutori_block').length) {
  var cnt = $('.l-main section form').length;

  for (let i = 0; i < cnt; i++) {

    var url = $('.l-main section form').eq(i).attr('action');

    if (!isMobile(768)) {
      // $('body').addClass('is-pc');
    } else {
      // $('body').addClass('is-sp');

      var fixUrl = url.replace("#kago", "")

      $('.l-main section form').eq(i).attr("action", fixUrl);
    }
  }
}

